<script>
  export default {
    inheritAttrs: false,
    name: 'render',
    props: {
      viewContent: [Array, Object]
    },
    render (h) {
      let viewContent = this.viewContent
      if (!viewContent) {
        return
      }
      if (!Array.isArray(viewContent)) {
        viewContent = [viewContent]
      }
      return (
        <div class="render">
          {
            viewContent.map(node => {
              if (typeof node === 'string') {
                return <span class='render-string'>{node}</span>
              }
              /* eslint-disable */
              const Component = node.viewComponentName
              return <Component node={node} {...{props: node.props}} {...{props: this.$attrs}}/>
            })
          }
        </div>
      )
    }
  }
</script>

<style lang="scss">
  // div.render {
  //   display: inline;
  // }
</style>
